(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxx-configurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('boxx-configurator')) {
  customElements.define('boxx-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      this.update();
    }
    update() {
      const variant = this.form.elements.variant.selectedOptions[0];
      const quantity = Math.max(1, Math.floor(Number(this.form.elements.quantity.value) || 1));
      const extra = [...this.querySelectorAll('[data-addon]:checked')].reduce((sum, input) => sum + Number(input.dataset.price), 0);
      this.querySelector('[data-total]').textContent = this.format.format((Number(variant.dataset.price) + extra) * quantity / 100);
      this.button.disabled = variant.dataset.available !== 'true';
      this.querySelector('[data-error]').textContent = this.button.disabled ? this.querySelector('[data-unavailable]').textContent : '';
    }
    async submit(event) {
      event.preventDefault();
      if (!this.form.reportValidity() || this.button.disabled) return;
      const quantity = Number(this.form.elements.quantity.value);
      const group = crypto.randomUUID();
      const freight = this.querySelector('[data-freight]').textContent;
      const items = [{id:Number(this.form.elements.variant.value),quantity,properties:{Freight:freight,_boxx_group:group}}];
      this.querySelectorAll('[data-addon]:checked').forEach(input => items.push({id:Number(input.dataset.addon),quantity,properties:{'For machine':this.dataset.title,_boxx_group:group}}));
      this.button.disabled = true;
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.querySelector('[data-failed]').textContent);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.querySelector('[data-error]').textContent = error.message;
        this.button.disabled = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
